import React from 'react';
import NavBar from '../../../../components/NavBar';

/*
 This component is used for the Quest header if "showHeader" is set to true
*/
export default () => <NavBar noLogoLink />;
